import { parseHtmlToJson } from './utils/htmlTransformations';
import type { HTMLElementSimplified } from '~/components/components/cms/wysiwyg/types';
/**
 * @Description
 * Parses a string to HTML and then maps the HTML-Tags+Content to specific vue-components
 * @returns
 *  Vue Render Function with VNodes
 */
export default async function transformHTMLToJson(
  htmlString: string,
  filterElements?: (
    content: HTMLElementSimplified[],
  ) => HTMLElementSimplified[],
): Promise<Array<HTMLElementSimplified>> {
  let contentAsDomDocument: Document;

  if (!import.meta.client) {
    const jsdomParser = await import('./utils/jsdomParser');
    contentAsDomDocument = jsdomParser.parseHtmlString(htmlString);
  } else {
    const parser = new window.DOMParser();
    contentAsDomDocument = parser.parseFromString(htmlString, 'text/html');
  }

  if (contentAsDomDocument.body && !filterElements) {
    return parseHtmlToJson(contentAsDomDocument);
  }

  if (contentAsDomDocument.body && typeof filterElements === 'function') {
    return filterElements(parseHtmlToJson(contentAsDomDocument));
  }
  return [];
}
